// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ContactUsSetting_container__u78oy {
    padding-top: 5rem;
    max-width: 1200px;
    margin: 0 auto;
  }
  
  .ContactUsSetting_header__5RTVV {
    display: flex;
    align-items: center;
    margin-bottom: 32px;
  }
  
  .ContactUsSetting_headerIcon__L4GjQ {
    font-size: 32px;
    margin-right: 16px;
    color: #ffffff;
  }
  
  .ContactUsSetting_title__2dDDY {
    font-size: 24px;
    font-weight: 600;
    margin: 0;
    color: #ffffff;
  }
  
  .ContactUsSetting_subtitle__o3d0c {
    font-size: 14px;
    color: #6b7280;
    margin: 4px 0 0;
  }
  
  .ContactUsSetting_sectionContainer__F9Igl {
    background-color: #383838;
    border-radius: 8px;
    padding: 24px;
    margin-bottom: 24px;
    box-shadow: 0 1px 3px rgba(206, 21, 21, 0.352);
  }
  
  .ContactUsSetting_sectionTitle__DMtC2 {
    font-size: 18px;
    font-weight: 600;
    margin-top: 0;
    margin-bottom: 20px;
    color:#ffffff;
    border-bottom: 1px solid #e5e7eb;
    padding-bottom: 12px;
  }
  
  /* Table styling with black and red theme */
  .ContactUsSetting_tableContainer__d4ikL {
    overflow-x: auto;
    margin-bottom: 16px;
  }
  
  .ContactUsSetting_inquiryTable__2Trpi {
    width: 100%;
    border-collapse: collapse;
    font-size: 14px;
    border: 1px solid #000000;
    color: white;
  
  }
  
  .ContactUsSetting_inquiryTable__2Trpi thead {
    background-color: #000000;
    }
  
  .ContactUsSetting_inquiryTable__2Trpi th {
    padding: 12px 15px;
    text-align: left;
    font-weight: 600;
    border-right: 1px solid #222222;
  }
  
  .ContactUsSetting_inquiryTable__2Trpi th:last-child {
    border-right: none;
  }
  
  .ContactUsSetting_inquiryTable__2Trpi tbody tr {
    border-bottom: 1px solid #dddddd;
    transition: background-color 0.2s ease;
  }
  
  .ContactUsSetting_inquiryTable__2Trpi tbody tr:nth-child(even) {
    background-color: #646464d6;
  }
  
  .ContactUsSetting_inquiryTable__2Trpi tbody tr:hover {
    background-color: #292626;
  }
  
  .ContactUsSetting_inquiryTable__2Trpi td {
    padding: 12px 15px;
    border-right: 1px solid #dddddd;
  }
  
  .ContactUsSetting_inquiryTable__2Trpi td:last-child {
    border-right: none;
  }
  
  .ContactUsSetting_actionButtons__32sm0 {
    display: flex;
    gap: 8px;
    justify-content: center;
  }
  
  .ContactUsSetting_viewButton__IpZXJ, .ContactUsSetting_deleteButton__Zbj37 {
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
    border-radius: 4px;
    width: 32px;
    height: 32px;
    cursor: pointer;
    transition: background-color 0.2s ease;
  }
  
  .ContactUsSetting_viewButton__IpZXJ {
    background-color: #000000;
    color: white;
  }
  
  .ContactUsSetting_viewButton__IpZXJ:hover {
    background-color: #333333;
  }
  
  .ContactUsSetting_deleteButton__Zbj37 {
    background-color: #dc2626;
    color: white;
  }
  
  .ContactUsSetting_deleteButton__Zbj37:hover {
    background-color: #b91c1c;
  }
  
  /* Modal styling */
  .ContactUsSetting_modalOverlay__H6Ubi {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgb(0 0 0 / 65%);;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
  }
  
  .ContactUsSetting_modal__DCVTS {
    background-color: #1f1f1f; /* Dark background */
    border-radius: 8px;
    width: 90%;
    max-width: 600px;
    max-height: 90vh;
    overflow-y: auto;
    box-shadow: 0 4px 6px rgba(255, 255, 255, 0.1);
    display: flex;
    flex-direction: column;
  }
  
  .ContactUsSetting_modalHeader__Jn9vK {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px 24px;
    border-bottom: 1px solid #333333;
    background-color: #111111; /* Dark header */
    color: white;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
  }
  
  .ContactUsSetting_modalHeader__Jn9vK h2 {
    margin: 0;
    font-size: 18px;
    font-weight: 600;
  }
  
  .ContactUsSetting_closeButton__2j-5I {
    background: none;
    border: none;
    color: white;
    cursor: pointer;
    padding: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    transition: background-color 0.2s ease;
  }
  
  .ContactUsSetting_closeButton__2j-5I:hover {
    background-color: rgba(255, 255, 255, 0.1);
  }
  
  .ContactUsSetting_modalBody__WNhx4 {
    padding: 24px;
    display: flex;
    flex-direction: column;
    gap: 16px;
    background-color: #1a1a1a; /* Darker background for contrast */
  }
  
  .ContactUsSetting_detailItem__2c4XB {
    display: flex;
    align-items: flex-start;
    gap: 12px;
  }
  
  .ContactUsSetting_detailIcon__mvben {
    color: #ff2020;
    min-width: 20px;
  }
  
  .ContactUsSetting_detailLabel__9s71V {
    font-size: 12px;
    font-weight: 500;
    color: #a0a0a0; /* Light gray text */
    margin-bottom: 4px;
  }
  
  .ContactUsSetting_detailValue__6q7aK {
    font-size: 14px;
    color: #ffffff; /* White text for better visibility */
    word-break: break-word;
  }
  

  .ContactUsSetting_statusContainer__MA5LL {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }
  
  .ContactUsSetting_statusBadge__yJDCw {
    display: inline-block;
    padding: 4px 8px;
    border-radius: 4px;
    font-size: 12px;
    font-weight: 500;
    color: white;
  }
  
  .ContactUsSetting_unread__BBabI {
    background-color: #3b82f6;
  }
  
  .ContactUsSetting_inprogress__ZWNA2 {
    background-color: #f59e0b;
  }
  
  .ContactUsSetting_reviewed__n411H {
    background-color: #8b5cf6;
  }
  
  .ContactUsSetting_completed__x0\\+q7 {
    background-color: #10b981;
  }
  
  .ContactUsSetting_modalFooter__wfx0A {
    padding: 16px 24px;
    border-top: 1px solid #e5e7eb;
    display: flex;
    justify-content: flex-end;
    gap: 12px;
  }
  
  .ContactUsSetting_replyButton__p1dl0, .ContactUsSetting_closeModalButton__DyWzf {
    padding: 8px 16px;
    border-radius: 6px;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    transition: background-color 0.2s ease;
  }
  
  .ContactUsSetting_replyButton__p1dl0 {
    background-color: #a11f1f;
    color: white;
    border: none;
  }
  
  .ContactUsSetting_replyButton__p1dl0:hover {
    background-color: #7c0000;
  }
  
  .ContactUsSetting_closeButton__2j-5I {
    background: none;
    border: none;
    color: white;
    cursor: pointer;
    padding: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    transition: background-color 0.2s ease;
  }
  
  .ContactUsSetting_closeButton__2j-5I:hover {
    background-color: rgba(255, 255, 255, 0.1);
  }
  /*pop up alert*/
  .ContactUsSetting_confirmButton__vZRIb {
    background: #cf6679;
    color: white;
    padding: 8px 12px;
    border: none;
    cursor: pointer;
    border-radius: 5px;
    font-size: 14px;
    }
  
  .ContactUsSetting_confirmButton__vZRIb:hover {
    background: #b00020;
  }
  
  .ContactUsSetting_cancelButton__4jjH- {
    background: #333;
    color: white;
    padding: 8px 12px;
    border: none;
    cursor: pointer;
    border-radius: 5px;
    font-size: 14px;
  }
  
  .ContactUsSetting_cancelButton__4jjH-:hover {
    background: #282828;
  }
  .ContactUsSetting_replyTextArea__Q0GRe {
    font-size: 14px;
    color: #e5e5e5; /* Lighter gray text */
    background-color: #8080801f; /* Dark background */
    border: 1px solid #3a3a3a; /* Subtle border */
    border-radius: 6px;
    padding: 12px;
    min-height: 80px;
    line-height: 1.5;
  }
    
  .ContactUsSetting_messageContent__U8JQu {
      font-size: 14px;
      color: #e5e5e5; /* Lighter gray text */
      background-color: #292929; /* Dark background */
      border: 1px solid #3a3a3a; /* Subtle border */
      border-radius: 6px;
      padding: 12px;
      min-height: 80px;
      line-height: 1.5;
    }
    
  /* Responsive adjustments */
  @media (max-width: 768px) {
    .ContactUsSetting_sectionContainer__F9Igl {
      padding: 16px;
    }
    
    .ContactUsSetting_inquiryTable__2Trpi {
      font-size: 13px;
    }
    
    .ContactUsSetting_actionButtons__32sm0 {
      gap: 4px;
    }
    
    .ContactUsSetting_viewButton__IpZXJ, .ContactUsSetting_deleteButton__Zbj37 {
      width: 28px;
      height: 28px;
    }
    
    .ContactUsSetting_modal__DCVTS {
      width: 95%;
    }
    
    .ContactUsSetting_modalBody__WNhx4 {
      padding: 16px;
    }
  }`, "",{"version":3,"sources":["webpack://./src/admin/pages/content/components/ContactUsSetting.module.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,kBAAkB;IAClB,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,SAAS;IACT,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,8CAA8C;EAChD;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,aAAa;IACb,gCAAgC;IAChC,oBAAoB;EACtB;;EAEA,2CAA2C;EAC3C;IACE,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,yBAAyB;IACzB,eAAe;IACf,yBAAyB;IACzB,YAAY;;EAEd;;EAEA;IACE,yBAAyB;IACzB;;EAEF;IACE,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,+BAA+B;EACjC;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,gCAAgC;IAChC,sCAAsC;EACxC;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,kBAAkB;IAClB,+BAA+B;EACjC;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,QAAQ;IACR,uBAAuB;EACzB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,eAAe;IACf,sCAAsC;EACxC;;EAEA;IACE,yBAAyB;IACzB,YAAY;EACd;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;IACzB,YAAY;EACd;;EAEA;IACE,yBAAyB;EAC3B;;EAEA,kBAAkB;EAClB;IACE,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,kCAAkC;IAClC,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;EACf;;EAEA;IACE,yBAAyB,EAAE,oBAAoB;IAC/C,kBAAkB;IAClB,UAAU;IACV,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,8CAA8C;IAC9C,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;IAClB,gCAAgC;IAChC,yBAAyB,EAAE,gBAAgB;IAC3C,YAAY;IACZ,2BAA2B;IAC3B,4BAA4B;EAC9B;;EAEA;IACE,SAAS;IACT,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,sCAAsC;EACxC;;EAEA;IACE,0CAA0C;EAC5C;;EAEA;IACE,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,yBAAyB,EAAE,mCAAmC;EAChE;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,cAAc,EAAE,oBAAoB;IACpC,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,cAAc,EAAE,qCAAqC;IACrD,sBAAsB;EACxB;;;EAGA;IACE,aAAa;IACb,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,qBAAqB;IACrB,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,kBAAkB;IAClB,6BAA6B;IAC7B,aAAa;IACb,yBAAyB;IACzB,SAAS;EACX;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,sCAAsC;EACxC;;EAEA;IACE,yBAAyB;IACzB,YAAY;IACZ,YAAY;EACd;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,gBAAgB;IAChB,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,sCAAsC;EACxC;;EAEA;IACE,0CAA0C;EAC5C;EACA,eAAe;EACf;IACE,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;IACjB,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,eAAe;IACf;;EAEF;IACE,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,YAAY;IACZ,iBAAiB;IACjB,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,mBAAmB;EACrB;EACA;IACE,eAAe;IACf,cAAc,EAAE,sBAAsB;IACtC,2BAA2B,EAAE,oBAAoB;IACjD,yBAAyB,EAAE,kBAAkB;IAC7C,kBAAkB;IAClB,aAAa;IACb,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;MACI,eAAe;MACf,cAAc,EAAE,sBAAsB;MACtC,yBAAyB,EAAE,oBAAoB;MAC/C,yBAAyB,EAAE,kBAAkB;MAC7C,kBAAkB;MAClB,aAAa;MACb,gBAAgB;MAChB,gBAAgB;IAClB;;EAEF,2BAA2B;EAC3B;IACE;MACE,aAAa;IACf;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,QAAQ;IACV;;IAEA;MACE,WAAW;MACX,YAAY;IACd;;IAEA;MACE,UAAU;IACZ;;IAEA;MACE,aAAa;IACf;EACF","sourcesContent":[".container {\n    padding-top: 5rem;\n    max-width: 1200px;\n    margin: 0 auto;\n  }\n  \n  .header {\n    display: flex;\n    align-items: center;\n    margin-bottom: 32px;\n  }\n  \n  .headerIcon {\n    font-size: 32px;\n    margin-right: 16px;\n    color: #ffffff;\n  }\n  \n  .title {\n    font-size: 24px;\n    font-weight: 600;\n    margin: 0;\n    color: #ffffff;\n  }\n  \n  .subtitle {\n    font-size: 14px;\n    color: #6b7280;\n    margin: 4px 0 0;\n  }\n  \n  .sectionContainer {\n    background-color: #383838;\n    border-radius: 8px;\n    padding: 24px;\n    margin-bottom: 24px;\n    box-shadow: 0 1px 3px rgba(206, 21, 21, 0.352);\n  }\n  \n  .sectionTitle {\n    font-size: 18px;\n    font-weight: 600;\n    margin-top: 0;\n    margin-bottom: 20px;\n    color:#ffffff;\n    border-bottom: 1px solid #e5e7eb;\n    padding-bottom: 12px;\n  }\n  \n  /* Table styling with black and red theme */\n  .tableContainer {\n    overflow-x: auto;\n    margin-bottom: 16px;\n  }\n  \n  .inquiryTable {\n    width: 100%;\n    border-collapse: collapse;\n    font-size: 14px;\n    border: 1px solid #000000;\n    color: white;\n  \n  }\n  \n  .inquiryTable thead {\n    background-color: #000000;\n    }\n  \n  .inquiryTable th {\n    padding: 12px 15px;\n    text-align: left;\n    font-weight: 600;\n    border-right: 1px solid #222222;\n  }\n  \n  .inquiryTable th:last-child {\n    border-right: none;\n  }\n  \n  .inquiryTable tbody tr {\n    border-bottom: 1px solid #dddddd;\n    transition: background-color 0.2s ease;\n  }\n  \n  .inquiryTable tbody tr:nth-child(even) {\n    background-color: #646464d6;\n  }\n  \n  .inquiryTable tbody tr:hover {\n    background-color: #292626;\n  }\n  \n  .inquiryTable td {\n    padding: 12px 15px;\n    border-right: 1px solid #dddddd;\n  }\n  \n  .inquiryTable td:last-child {\n    border-right: none;\n  }\n  \n  .actionButtons {\n    display: flex;\n    gap: 8px;\n    justify-content: center;\n  }\n  \n  .viewButton, .deleteButton {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border: none;\n    border-radius: 4px;\n    width: 32px;\n    height: 32px;\n    cursor: pointer;\n    transition: background-color 0.2s ease;\n  }\n  \n  .viewButton {\n    background-color: #000000;\n    color: white;\n  }\n  \n  .viewButton:hover {\n    background-color: #333333;\n  }\n  \n  .deleteButton {\n    background-color: #dc2626;\n    color: white;\n  }\n  \n  .deleteButton:hover {\n    background-color: #b91c1c;\n  }\n  \n  /* Modal styling */\n  .modalOverlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: rgb(0 0 0 / 65%);;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 1000;\n  }\n  \n  .modal {\n    background-color: #1f1f1f; /* Dark background */\n    border-radius: 8px;\n    width: 90%;\n    max-width: 600px;\n    max-height: 90vh;\n    overflow-y: auto;\n    box-shadow: 0 4px 6px rgba(255, 255, 255, 0.1);\n    display: flex;\n    flex-direction: column;\n  }\n  \n  .modalHeader {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 16px 24px;\n    border-bottom: 1px solid #333333;\n    background-color: #111111; /* Dark header */\n    color: white;\n    border-top-left-radius: 8px;\n    border-top-right-radius: 8px;\n  }\n  \n  .modalHeader h2 {\n    margin: 0;\n    font-size: 18px;\n    font-weight: 600;\n  }\n  \n  .closeButton {\n    background: none;\n    border: none;\n    color: white;\n    cursor: pointer;\n    padding: 4px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 4px;\n    transition: background-color 0.2s ease;\n  }\n  \n  .closeButton:hover {\n    background-color: rgba(255, 255, 255, 0.1);\n  }\n  \n  .modalBody {\n    padding: 24px;\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n    background-color: #1a1a1a; /* Darker background for contrast */\n  }\n  \n  .detailItem {\n    display: flex;\n    align-items: flex-start;\n    gap: 12px;\n  }\n  \n  .detailIcon {\n    color: #ff2020;\n    min-width: 20px;\n  }\n  \n  .detailLabel {\n    font-size: 12px;\n    font-weight: 500;\n    color: #a0a0a0; /* Light gray text */\n    margin-bottom: 4px;\n  }\n  \n  .detailValue {\n    font-size: 14px;\n    color: #ffffff; /* White text for better visibility */\n    word-break: break-word;\n  }\n  \n\n  .statusContainer {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n  }\n  \n  .statusBadge {\n    display: inline-block;\n    padding: 4px 8px;\n    border-radius: 4px;\n    font-size: 12px;\n    font-weight: 500;\n    color: white;\n  }\n  \n  .unread {\n    background-color: #3b82f6;\n  }\n  \n  .inprogress {\n    background-color: #f59e0b;\n  }\n  \n  .reviewed {\n    background-color: #8b5cf6;\n  }\n  \n  .completed {\n    background-color: #10b981;\n  }\n  \n  .modalFooter {\n    padding: 16px 24px;\n    border-top: 1px solid #e5e7eb;\n    display: flex;\n    justify-content: flex-end;\n    gap: 12px;\n  }\n  \n  .replyButton, .closeModalButton {\n    padding: 8px 16px;\n    border-radius: 6px;\n    font-size: 14px;\n    font-weight: 500;\n    cursor: pointer;\n    transition: background-color 0.2s ease;\n  }\n  \n  .replyButton {\n    background-color: #a11f1f;\n    color: white;\n    border: none;\n  }\n  \n  .replyButton:hover {\n    background-color: #7c0000;\n  }\n  \n  .closeButton {\n    background: none;\n    border: none;\n    color: white;\n    cursor: pointer;\n    padding: 4px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 4px;\n    transition: background-color 0.2s ease;\n  }\n  \n  .closeButton:hover {\n    background-color: rgba(255, 255, 255, 0.1);\n  }\n  /*pop up alert*/\n  .confirmButton {\n    background: #cf6679;\n    color: white;\n    padding: 8px 12px;\n    border: none;\n    cursor: pointer;\n    border-radius: 5px;\n    font-size: 14px;\n    }\n  \n  .confirmButton:hover {\n    background: #b00020;\n  }\n  \n  .cancelButton {\n    background: #333;\n    color: white;\n    padding: 8px 12px;\n    border: none;\n    cursor: pointer;\n    border-radius: 5px;\n    font-size: 14px;\n  }\n  \n  .cancelButton:hover {\n    background: #282828;\n  }\n  .replyTextArea {\n    font-size: 14px;\n    color: #e5e5e5; /* Lighter gray text */\n    background-color: #8080801f; /* Dark background */\n    border: 1px solid #3a3a3a; /* Subtle border */\n    border-radius: 6px;\n    padding: 12px;\n    min-height: 80px;\n    line-height: 1.5;\n  }\n    \n  .messageContent {\n      font-size: 14px;\n      color: #e5e5e5; /* Lighter gray text */\n      background-color: #292929; /* Dark background */\n      border: 1px solid #3a3a3a; /* Subtle border */\n      border-radius: 6px;\n      padding: 12px;\n      min-height: 80px;\n      line-height: 1.5;\n    }\n    \n  /* Responsive adjustments */\n  @media (max-width: 768px) {\n    .sectionContainer {\n      padding: 16px;\n    }\n    \n    .inquiryTable {\n      font-size: 13px;\n    }\n    \n    .actionButtons {\n      gap: 4px;\n    }\n    \n    .viewButton, .deleteButton {\n      width: 28px;\n      height: 28px;\n    }\n    \n    .modal {\n      width: 95%;\n    }\n    \n    .modalBody {\n      padding: 16px;\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `ContactUsSetting_container__u78oy`,
	"header": `ContactUsSetting_header__5RTVV`,
	"headerIcon": `ContactUsSetting_headerIcon__L4GjQ`,
	"title": `ContactUsSetting_title__2dDDY`,
	"subtitle": `ContactUsSetting_subtitle__o3d0c`,
	"sectionContainer": `ContactUsSetting_sectionContainer__F9Igl`,
	"sectionTitle": `ContactUsSetting_sectionTitle__DMtC2`,
	"tableContainer": `ContactUsSetting_tableContainer__d4ikL`,
	"inquiryTable": `ContactUsSetting_inquiryTable__2Trpi`,
	"actionButtons": `ContactUsSetting_actionButtons__32sm0`,
	"viewButton": `ContactUsSetting_viewButton__IpZXJ`,
	"deleteButton": `ContactUsSetting_deleteButton__Zbj37`,
	"modalOverlay": `ContactUsSetting_modalOverlay__H6Ubi`,
	"modal": `ContactUsSetting_modal__DCVTS`,
	"modalHeader": `ContactUsSetting_modalHeader__Jn9vK`,
	"closeButton": `ContactUsSetting_closeButton__2j-5I`,
	"modalBody": `ContactUsSetting_modalBody__WNhx4`,
	"detailItem": `ContactUsSetting_detailItem__2c4XB`,
	"detailIcon": `ContactUsSetting_detailIcon__mvben`,
	"detailLabel": `ContactUsSetting_detailLabel__9s71V`,
	"detailValue": `ContactUsSetting_detailValue__6q7aK`,
	"statusContainer": `ContactUsSetting_statusContainer__MA5LL`,
	"statusBadge": `ContactUsSetting_statusBadge__yJDCw`,
	"unread": `ContactUsSetting_unread__BBabI`,
	"inprogress": `ContactUsSetting_inprogress__ZWNA2`,
	"reviewed": `ContactUsSetting_reviewed__n411H`,
	"completed": `ContactUsSetting_completed__x0+q7`,
	"modalFooter": `ContactUsSetting_modalFooter__wfx0A`,
	"replyButton": `ContactUsSetting_replyButton__p1dl0`,
	"closeModalButton": `ContactUsSetting_closeModalButton__DyWzf`,
	"confirmButton": `ContactUsSetting_confirmButton__vZRIb`,
	"cancelButton": `ContactUsSetting_cancelButton__4jjH-`,
	"replyTextArea": `ContactUsSetting_replyTextArea__Q0GRe`,
	"messageContent": `ContactUsSetting_messageContent__U8JQu`
};
export default ___CSS_LOADER_EXPORT___;
